export { SharedAuthPage } from './SharedAuthPage';
export { SharedAuthProvider, useSharedAuth } from '../../lib/auth/SharedAuthProvider';
export { getAuthConfig, defaultAuthConfig, appConfigs } from '../../lib/auth/auth-config';
export type { AuthConfig } from '../../lib/auth/auth-config';
